import { Status } from "interfaces/Occurrence";
import { client } from "./api";
import { timeDiff } from "utils/formatReportData";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { IGetByReport, IUpdateReport } from "interfaces/Report";
import { formatReportData } from "utils/formatReportData";
import { calculateAdditionalTime } from "utils/calculateAdditionalTime";


export async function getReportPdf(id: string) {
  const api = client();
  return await api.get(`reports/exports/${id}/generate/pdf`, {
    responseType: "blob",
  });
}

export async function getReportDocx(id: string) {
  const api = client();
  const buffer = await api.get(`reports/exports/${id}/generate/docx`, {
    responseType: "blob",
  });

  return buffer
}

export async function getReport(id: string) {
  const api = client();

  const response = await api.get(`reports/one`, {
    params: {
      where: { id },
      relations: {
        policeman: {
          user: true,
        },
        attachments: true,
        occurrence: {
          attendant: true,
          comments: true,
           superficialVehicle:true,
           client: {
            product: true
          },
          occurrencesSuperficialAddresses:{superficialAddress:{superficialClient:true}},
        },
      },
    }
    }
  );
  
  response.data.item.occurrence.client.product.regions = JSON.parse(
    response.data.item.occurrence.client.product.stringRegions
  );

  return response;
}

export async function acceptPictures(reportId: string) {
  const api = client();
  await api.patch("reports/review-pictures", {
    reportId,
    accepted: true,
  });
  window.location.reload();
  return;
}

export async function denyPictures(
  reportId: string,
  description: string,
) {
  const api = client();
  await api.patch("reports/review-pictures", {
    reportId,
    description,
    accepted: false
  });
}
export interface IExportsProps {
  policeman?: string;
  start?: Date;
  finish?: Date;
  type?: boolean | undefined;
  lat?: number;
  lng?: number;
  range?: number;
}

export async function getReports({
  policeman,
  start,
  finish,
  type,
  lat,
  lng,
  range,
}: IExportsProps) {
  const api = client();
  return await api.post(
    "reports/exports/generate",
    {
      policeman,
      start,
      finish,
      type: type === undefined ? undefined : type === true ? 1 : 2,
      lat,
      lng,
      range,
    },
    { responseType: "blob" }
  );
}
export async function getReportsToExcel({
  policeman,
  start,
  finish,
  type,
  lat,
  lng,
  range,
}: IExportsProps) {
  const api = client();

  const response = await api.get("reports/exports", {
    params: {
      policeman,
      start,
      finish,
      type: type === undefined ? undefined : type === true ? 1 : 2,
      isExcel: true,
      lat: lat || undefined,
      lng: lng || undefined,
      range,
    },
    responseType: "blob",
  });
  return response as any
}
export async function getMaintenanceReportsToExcel({
  start,
  finish,
}: {
  start?: Date;
  finish?: Date;
}) {
  const api = client();

  const response = await api.get("maintenance/exports", {
    params: {
      start,
      finish,
    },
    responseType: "blob",
  });
  return response as any
}
export async function getPaymentReports({
  policeman,
  start,
  finish,
}: IExportsProps) {
  const api = client();
  return await api.post(
    `payments/export/generate`,
    {
      policeman,
      start,
      finish,
    },
    {
      responseType: "blob",
    }
  );
}

export interface IExportEfficiencyProps {
  id: string;
  period?: {
    since?: Date;
    until?: Date;
  };
}

export async function getEfficiencyReport(params: IExportEfficiencyProps) {
  const api = client();

  return api.post(
    `policemen/exports/generate/efficiency`,
    { ...params },
    { responseType: "blob" }
  );
}

export async function updateReportService({ pr, rec, report }: IUpdateReport) {
  const api = client();
  return await api.patch("reports", {
    pr,
    rec,
    id: report.id,
  });
}
